/* RESPONSIBLE TEAM: team-reporting */
import Helper from '@ember/component/helper';

export default class JsonHelper extends Helper {
  compute(params) {
    let [value] = params;
    return JSON.stringify(value, null, 2);
  }
}
